export default function Preloader() {
    return (
        <>
            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundSize: 'cover' }}>
                <div className="loader"></div>
            </div>
        </>
    )
}